import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  TextField,
  MenuItem,
  Button,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Grid,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { Imagen } from "./Obtener/ImganeForm";
import Swal from "sweetalert2";
import loadingGif from "../img/Icontec.gif";

const Unificado = () => {
  let { id } = useParams();
  const [campos, setCampos] = useState([]);
  const [valoresFormulario, setValoresFormulario] = useState({});
  const [aceptarDatos, setAceptarDatos] = useState(false);
  const [titulo, setTitulo] = useState(""); // Estado para título
  const [lineaServicio, setLineaServicio] = useState(""); // Estado para línea de servicio
  const [Canal, setCanal] = useState("");

  const [estadoPais, setEstadoPais] = useState({
    ciudad: "",
    estado: "",
    pais: "",
  });
  const [paises, setPaises] = useState([]); // Lista de países
  const [estados, setEstados] = useState([]); // Lista de estados según el país
  const [ciudades, setCiudades] = useState([]); // Estado para almacenar los países

  // Obtener los países desde la API
  useEffect(() => {
    axios
      .get("https://portaltransaccionalback.azurewebsites.net/api/ObtienePais")
      .then((response) => {
        setPaises(response.data);
      })
      .catch((error) => {
        console.error("Error al obtener los países:", error);
      });
  }, []);

  // Obtener los campos desde la API
  useEffect(() => {
    axios
      .get(
        "https://portaltransaccionalback.azurewebsites.net/api/GetFormularios/" +
          id
      )
      .then((response) => {
        if (response.data && response.data.length > 0) {
          const processedData = response.data.map((campo) => {
            // Verificar explícitamente si 's' y 'a' existen
            const idS = campo.s && campo.s.id ? campo.s.id : null;
            const titulo =
              campo.a && campo.a.titulo
                ? campo.a.titulo
                : "Título no disponible";
            const lineaServicio =
              campo.a && campo.a.lineaServicio
                ? campo.a.lineaServicio
                : "Línea no disponible";
            const canal =
              campo.a && campo.a.canal ? campo.a.canal : "canal no disponible";
            console.log(canal);
            setCanal(canal);
            return {
              idS,
              titulo,
              lineaServicio,
              canal, // Guardar línea de servicio o mensaje predeterminado
              s: campo.s || null, // Guardar 's' completo o null si no existe
              a: campo.a || {}, // Guardar 'a' completo o un objeto vacío
              opciones: campo.opciones || null, // Guardar 'opciones' o null
            };
          });

          console.log("Datos procesados:", processedData);

          // Actualizar estados con el primer elemento válido
          if (processedData.length > 0) {
            const { titulo, lineaServicio } = processedData[0];
            setTitulo(titulo);
            setLineaServicio(lineaServicio);
          }

          // Guardar todos los datos procesados
          setCampos(processedData);

          // Inicializar valores con los datos procesados
          inicializarValores(processedData);
        } else {
          console.warn("La respuesta del API está vacía o no contiene datos.");
        }
      })
      .catch((error) => {
        console.error("Error al obtener los datos:", error);
      });
  }, [id]);

  // Manejar cambio en el país
  const manejarCambioPais = (idPais) => {
    const paisSeleccionado = paises.find((pais) => pais.id === idPais);
    setEstadoPais({
      ...estadoPais,
      paisId: idPais,
      paisNombre: paisSeleccionado?.nombre || "",
      estadoId: "",
      estadoNombre: "",
      ciudadId: "",
      ciudadNombre: "",
    });
    axios
      .get(
        `https://portaltransaccionalback.azurewebsites.net/api/ObtieneEstado/${idPais}`
      )
      .then((response) => {
        setEstados(response.data);
        setCiudades([]);
      })
      .catch((error) => {
        console.error("Error al obtener los estados:", error);
      });
  };

  // Manejar cambio en el estado
  const manejarCambioEstado = (idEstado) => {
    const estadoSeleccionado = estados.find((estado) => estado.id === idEstado);
    setEstadoPais({
      ...estadoPais,
      estadoId: idEstado,
      estadoNombre: estadoSeleccionado?.nombre || "",
      ciudadId: "",
      ciudadNombre: "",
    });
    axios
      .get(
        `https://portaltransaccionalback.azurewebsites.net/api/ObtieneCiudad/${idEstado}`
      )
      .then((response) => {
        setCiudades(response.data);
      })
      .catch((error) => {
        console.error("Error al obtener las ciudades:", error);
      });
  };

  // Manejar cambio en la ciudad
  const manejarCambioCiudad = (idCiudad) => {
    const ciudadSeleccionada = ciudades.find(
      (ciudad) => ciudad.id === idCiudad
    );
    setEstadoPais({
      ...estadoPais,
      ciudadId: idCiudad,
      ciudadNombre: ciudadSeleccionada?.nombre || "",
    });
  };

  // Inicializar valores del formulario
  const inicializarValores = (campos) => {
    const valoresIniciales = {};
    campos.forEach((campo) => {
      valoresIniciales[campo.s.id] = "";
    });
    valoresIniciales["fechaRegistro"] = new Date().toISOString().split("T")[0];
    valoresIniciales["nombreCompleto"] = "";
    valoresIniciales["identificacion"] = "";
    valoresIniciales["celular"] = "";
    valoresIniciales["correo"] = "";
    valoresIniciales["empresa"] = "";
    valoresIniciales["direccion"] = "";
    valoresIniciales["nit"] = "";
    valoresIniciales["tipoPersona"] = "";

    setValoresFormulario(valoresIniciales);
  };

  // Manejar cambios en los campos
  const manejarCambio = (id, valor) => {
    setValoresFormulario({
      ...valoresFormulario,
      [id]: valor,
    });
  };

  const limpiarFormulario = () => {
    window.location.reload("/");
  };
  const confirmarLimpieza = () => {
    Swal.fire({
      title: "¿Está seguro?",
      text: "Esto limpiará el formulario y no podrá revertirlo.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, limpiar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        limpiarFormulario();
      }
    });
  };
  // Validar formulario antes de enviarlo
  const validarFormulario = () => {
    const camposObligatorios = [
      "nombreCompleto",
      "identificacion",
      "celular",
      "correo",
    ];
    for (let campo of camposObligatorios) {
      if (!valoresFormulario[campo]) {
        alert("Todos los campos obligatorios deben ser completados.");
        return false;
      }
    }
    if (!aceptarDatos) {
      alert("Debes aceptar el tratamiento de datos personales.");
      return false;
    }
    return true;
  };

  // Manejar el envío del formulario
  const manejarEnvio = (e) => {
    e.preventDefault(); // Previene el comportamiento predeterminado del formulario.

    // Validación inicial para verificar campos obligatorios.
    if (
      !estadoPais ||
      !estadoPais.paisNombre ||
      estadoPais.paisNombre.trim() === ""
    ) {
      Swal.fire({
        icon: "warning",
        title: "Campo obligatorio",
        text: "Debe completar el campo de país.",
      });
      return;
    }

    if (!validarFormulario()) {
      // Si la validación del formulario falla, no procede.
      return;
    }

    const datosEnviar = {
      idPrincipal: id,
      fechaRegistro: new Date().toISOString().split("T")[0],
      nombreCompleto: valoresFormulario.nombreCompleto || "",
      identificacion: valoresFormulario.identificacion || "",
      tipoPersona: valoresFormulario.tipoPersona,
      celular: valoresFormulario.celular || "",
      correo: valoresFormulario.correo || "",
      empresa: valoresFormulario.empresa || "",
      nit: valoresFormulario.identificacion || "",
      pais: estadoPais.paisNombre,
      estado: estadoPais.estadoNombre,
      ciudad: estadoPais.ciudadNombre,
      tematica: valoresFormulario.tipoIdentificacion || "",
      direccion: valoresFormulario.direccion || "",
      titulo: titulo || "",
      lineaServicio: lineaServicio || "",
      autorizo: valoresFormulario.autorizacion || "",
      canal: Canal,
      Personalizados: campos.map((campo) => {
        if (campo.s) {
          return {
            nombreCampo: campo.s.nombre || "", // Asegúrate de que 'campo.s.nombre' no sea null
            Respuesta: valoresFormulario[campo.s.id] || "", // Asegúrate de que 'campo.s.id' no sea null
          };
        }
        return {
          nombreCampo: "", // Si 'campo.s' es null, asignar valor por defecto
          Respuesta: "", // Si 'campo.s' es null, asignar valor por defecto
        };
      }),
    };

    // Mostrar alerta de cargando con el GIF local.
    Swal.fire({
      title: "Cargando...",
      html: `
    <img src=${loadingGif} alt="Cargando..." width="100" />
    <p>Por favor, espera mientras se envían los datos.</p>
  `,
      showConfirmButton: false,
      allowOutsideClick: false,
    });

    // Envío de los datos mediante Axios
    axios
      .post(
        "https://portaltransaccionalback.azurewebsites.net/api/CreaRespuestaLead",
        datosEnviar
      )
      .then((response) => {
        console.log("Datos enviados correctamente:", response.data);
        Swal.fire({
          icon: "warning",
          title: "Mensaje",
          text: response.data,
        }).then(() => {
          window.location.reload("/"); // Recargar la página después de enviar los datos
        });
      })
      .catch((error) => {
        console.error("Error al enviar los datos:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Ocurrió un error al enviar el formulario." + error,
        });
      });
  };

  const renderCampo = (campo) => {
    // Verificar si 'campo.s' existe antes de intentar acceder a sus propiedades
    if (!campo || !campo.s) {
      return null; // Si no hay 'campo.s', no renderizar nada
    }

    const { id, tipo, nombre } = campo.s;

    // Verificar si 'id' y 'tipo' existen antes de continuar
    if (!id || !tipo) {
      return null; // Si no hay 'id' o 'tipo', no renderizar el campo
    }

    switch (tipo) {
      case "Correo":
        return (
          <TextField
            key={id}
            label={nombre || "Correo"} // Si 'nombre' es nulo, usa "Correo" como valor por defecto
            type="email"
            variant="outlined"
            fullWidth
            margin="normal"
            value={valoresFormulario[id] || ""}
            onChange={(e) => manejarCambio(id, e.target.value)}
          />
        );
      case "Numero":
        return (
          <TextField
            key={id}
            label={nombre || "Número"} // Si 'nombre' es nulo, usa "Número" como valor por defecto
            type="number"
            variant="outlined"
            fullWidth
            margin="normal"
            value={valoresFormulario[id] || ""}
            onChange={(e) => manejarCambio(id, e.target.value)}
          />
        );
      case "Fecha":
        return (
          <TextField
            key={id}
            label={nombre || "Fecha"} // Si 'nombre' es nulo, usa "Fecha" como valor por defecto
            type="date"
            variant="outlined"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={valoresFormulario[id] || ""}
            onChange={(e) => manejarCambio(id, e.target.value)}
          />
        );
      case "Texto":
        return (
          <TextField
            key={id}
            label={nombre || "Texto"} // Si 'nombre' es nulo, usa "Texto" como valor por defecto
            variant="outlined"
            fullWidth
            margin="normal"
            multiline
            rows={4}
            value={valoresFormulario[id] || ""}
            onChange={(e) => manejarCambio(id, e.target.value)}
          />
        );
      case "Opción Múltiple":
        return (
          <TextField
            key={id}
            label={nombre || "Opción Múltiple"} // Si 'nombre' es nulo, usa "Opción Múltiple" como valor por defecto
            select
            variant="outlined"
            fullWidth
            margin="normal"
            value={valoresFormulario[id] || ""}
            onChange={(e) => manejarCambio(id, e.target.value)}
          >
            {/* Verificar si 'campo.opciones' existe antes de iterar */}
            {(campo.opciones || []).map((opcion) => (
              <MenuItem key={opcion.id} value={opcion.opcion}>
                {opcion.opcion}
              </MenuItem>
            ))}
          </TextField>
        );
      default:
        return null; // Si no coincide con ningún tipo, no renderizar nada
    }
  };
  const codigosPais = [
    { codigo: "+57", pais: "Colombia" },
    { codigo: "+1", pais: "EE.UU." },
    { codigo: "+52", pais: "México" },
    { codigo: "+54", pais: "Argentina" },
    { codigo: "+34", pais: "España" },
  ];
  console.log(valoresFormulario.codigoPais + valoresFormulario.celular);
  return (
    <>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div
              className="card shadow mb-4"
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                padding: "20px",
                width: "50%", // Ajusta el ancho del card
                height: "auto", // Ajusta la altura del card
                margin: "0 auto", // Centra el card horizontalmente
              }}
            >
              <Box
                component="form"
                onSubmit={manejarEnvio}
                sx={{ maxWidth: 1100, margin: "auto", padding: 2 }}
              >
                <Imagen id={id} />
                <Typography variant="h5" marginBottom={2}>
                  {titulo}
                </Typography>

                <TextField
                  label="Nombre Completo"
                  fullWidth
                  margin="normal"
                  value={valoresFormulario.nombreCompleto}
                  onChange={(e) =>
                    manejarCambio("nombreCompleto", e.target.value)
                  }
                  required
                />
                <TextField
                  label="Tipo de Identificación"
                  select
                  fullWidth
                  margin="normal"
                  value={valoresFormulario.tipoIdentificacion}
                  onChange={(e) =>
                    manejarCambio("tipoIdentificacion", e.target.value)
                  }
                  required
                >
                  <MenuItem value="cedula">Cédula</MenuItem>
                  <MenuItem value="cedulaExtranjeria">
                    Cédula de Extranjería
                  </MenuItem>
                  <MenuItem value="pasaporte">Pasaporte</MenuItem>
                  <MenuItem value="otro">Otro</MenuItem>
                </TextField>
                <TextField
                  label="Número de Identificación"
                  fullWidth
                  margin="normal"
                  value={valoresFormulario.identificacion}
                  onChange={(e) =>
                    manejarCambio("identificacion", e.target.value)
                  }
                  required
                />
                <TextField
                  label="Tipo de Persona"
                  select
                  fullWidth
                  margin="normal"
                  value={valoresFormulario.tipoPersona}
                  onChange={(e) => manejarCambio("tipoPersona", e.target.value)}
                >
                  <MenuItem value="NATURAL">Persona Natural</MenuItem>
                  <MenuItem value="JURIDICA">Persona Jurídica</MenuItem>
                </TextField>

                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      label="Celular"
                      fullWidth
                      margin="normal"
                      value={valoresFormulario.celular}
                      onChange={(e) => manejarCambio("celular", e.target.value)}
                      required
                    />
                  </Grid>
                </Grid>
                <TextField
                  label="Correo Electrónico"
                  type="email"
                  fullWidth
                  margin="normal"
                  value={valoresFormulario.correo}
                  onChange={(e) => manejarCambio("correo", e.target.value)}
                  required
                />
                <TextField
                  label="País"
                  select
                  fullWidth
                  margin="normal"
                  value={estadoPais.paisId}
                  onChange={(e) => manejarCambioPais(e.target.value)}
                  required
                >
                  {paises.map((pais) => (
                    <MenuItem key={pais.id} value={pais.id}>
                      {pais.nombre}
                    </MenuItem>
                  ))}
                </TextField>

                {/* Campo Estado */}
                <TextField
                  label="Estado/Departamento"
                  select
                  fullWidth
                  margin="normal"
                  value={estadoPais.estadoId}
                  onChange={(e) => manejarCambioEstado(e.target.value)}
                  disabled={!estadoPais.paisId}
                  required
                >
                  {estados.map((estado) => (
                    <MenuItem key={estado.id} value={estado.id}>
                      {estado.nombre}
                    </MenuItem>
                  ))}
                </TextField>

                {/* Campo Ciudad */}
                <TextField
                  label="Ciudad"
                  select
                  fullWidth
                  margin="normal"
                  value={estadoPais.ciudadId}
                  onChange={(e) => manejarCambioCiudad(e.target.value)}
                  disabled={!estadoPais.estadoId}
                  required
                >
                  {ciudades.map((ciudad) => (
                    <MenuItem key={ciudad.id} value={ciudad.id}>
                      {ciudad.nombre}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  label="Direccion"
                  fullWidth
                  margin="normal"
                  value={valoresFormulario.direccion}
                  onChange={(e) => manejarCambio("direccion", e.target.value)}
                />

                <TextField
                  label="Nombre de la Empresa (Opcional)"
                  fullWidth
                  margin="normal"
                  value={valoresFormulario.empresa}
                  onChange={(e) => manejarCambio("empresa", e.target.value)}
                />

                {campos.map((campo) => renderCampo(campo))}

                <div>
                  ¿Autorizo a ICONTEC para contactarme y/o recibir información
                  de cursos, foros y eventos importantes con fines comerciales?
                </div>
                <br></br>
                <TextField
                  select
                  fullWidth
                  value={valoresFormulario.autorizacion}
                  label="seleccione"
                  onChange={(e) =>
                    manejarCambio("autorizacion", e.target.value)
                  }
                  required
                >
                  <MenuItem value="Si">Sí</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
                <br></br>
                <br></br>
                <div>
                  ICONTEC ha puesto a su disposición una política de privacidad,
                  protección y tratamiento de datos personales, la cual puede
                  consultar en <a href="https://bit.ly/45Kj1x6.">enlace</a> Para
                  información adicional sobre el tratamiento de sus datos
                  personales, póngase en contacto al e-mail cliente@icontec.org
                </div>
                <br></br>
                {/* Aceptación de datos */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={aceptarDatos}
                      onChange={(e) => setAceptarDatos(e.target.checked)}
                      name="aceptarDatos"
                    />
                  }
                  label={
                    <>
                      Acepto el tratamiento de datos que está disponible en{" "}
                      <a
                        href="https://www.icontec.org"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        www.icontec.org
                      </a>
                    </>
                  }
                />

                {/* Campos dinámicos */}

                <Box
                  display="flex"
                  justifyContent="space-between"
                  marginTop={2}
                >
                  <Button variant="outlined" onClick={confirmarLimpieza}>
                    Limpiar
                  </Button>
                  <Button type="submit" variant="contained" color="primary">
                    Enviar
                  </Button>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Unificado;
